export default {
  'launchpad.title': 'Launchpad',
  'launchpad.eyebrow': 'Your Launchpad',

  'launchpad.module.processes.title': 'Processes',
  'launchpad.module.processes.eyebrow': 'Your processes hub',
  'launchpad.module.lists.title': 'Lists',
  'launchpad.module.lists.eyebrow': 'Your custom lists',
  'launchpad.module.reports.title': 'Reports',
  'launchpad.module.reports.eyebrow': 'Your reports hub',
  'launchpad.module.agents.title': 'Agents',
  'launchpad.module.agents.eyebrow': 'Your intelligent assistants',
  'launchpad.module.agents.tab.jobs': 'Jobs',
  'launchpad.module.agents.tab.ai': 'Agents',
  'launchpad.module.agents.tab.rpa': 'RPA',
  'launchpad.module.agents.tab.skills': 'Skills',
  'launchpad.module.agents.tab.vectors': 'Vectors',
  'launchpad.module.apps.title': 'Apps',
  'launchpad.module.apps.eyebrow': 'Your apps gallery',
  'launchpad.module.connections.title': 'Connections',
  'launchpad.module.connections.eyebrow': 'Your connections & integrations',
  'launchpad.module.entities.title': 'Entities',
  'launchpad.module.entities.eyebrow': 'Your dynamic data model',

  'launchpad.type.processes': 'Processes',
  'launchpad.type.processes.singular': 'Process',
  'launchpad.type.lists': 'Lists',
  'launchpad.type.lists.singular': 'List',
  'launchpad.type.reports': 'Reports',
  'launchpad.type.reports.singular': 'Report',
  'launchpad.type.jobs': 'Jobs',
  'launchpad.type.jobs.singular': 'Job',
  'launchpad.type.agents': 'Agents',
  'launchpad.type.agents.singular': 'Agent',
  'launchpad.type.rpa': 'RPA',
  'launchpad.type.rpa.singular': 'RPA agent',
  'launchpad.type.skills': 'Skills',
  'launchpad.type.skills.singular': 'Skill',
  'launchpad.type.vectors': 'Vectors',
  'launchpad.type.vectors.singular': 'Vector',
  'launchpad.type.apps': 'Apps',
  'launchpad.type.apps.singular': 'App',
  'launchpad.type.connections': 'Connections',
  'launchpad.type.connections.singular': 'Connection',
  'launchpad.type.entities': 'Entities',
  'launchpad.type.entities.singular': 'Entity',

  'launchpad.switcher.aria': 'Switch content type',

  'launchpad.hero.welcome': 'Your workspace hub',
  'launchpad.hero.tagline.processes': 'Start processes, manage groups and favorites.',
  'launchpad.hero.tagline.lists': 'Browse lists, manage groups and favorites.',
  'launchpad.hero.tagline.reports': 'Query, filter and export reports.',
  'launchpad.hero.tagline.jobs':
    'Assign jobs to your agents, schedule runs and monitor their history.',
  'launchpad.hero.tagline.agents': 'Interact with AI agents and configure their behavior.',
  'launchpad.hero.tagline.rpa': 'Browse RPA agents and their automation flows.',
  'launchpad.hero.tagline.skills': 'Configure skills, control their state and publish versions.',
  'launchpad.hero.tagline.vectors':
    'Manage knowledge vectors, their files and availability for your agents.',
  'launchpad.hero.tagline.apps': 'Open the apps enabled for your account.',
  'launchpad.hero.tagline.connections':
    'Manage credentials, validate status and configure integrations.',
  'launchpad.hero.tagline.entities': 'Manage dynamic entities, their groups and records.',

  'launchpad.subtitle.loading.processes': 'Loading processes and groups…',
  'launchpad.subtitle.loading.lists': 'Loading lists and groups…',
  'launchpad.subtitle.loading.reports': 'Loading reports and groups…',
  'launchpad.subtitle.loading.jobs': 'Loading jobs…',
  'launchpad.subtitle.loading.agents': 'Loading agents…',
  'launchpad.subtitle.loading.rpa': 'Loading RPA agents…',
  'launchpad.subtitle.loading.skills': 'Loading skills…',
  'launchpad.subtitle.loading.vectors': 'Loading vectors…',
  'launchpad.subtitle.loading.apps': 'Loading apps…',
  'launchpad.subtitle.loading.connections': 'Loading connections and groups…',
  'launchpad.subtitle.loading.entities': 'Loading entities and groups…',
  'launchpad.subtitle.loading': 'Loading processes and groups…',
  'launchpad.subtitle.counts':
    '{processes, plural, one {# process} other {# processes}} · {groups, plural, one {# group} other {# groups}}',

  'launchpad.kpi.processes': 'Processes',
  'launchpad.kpi.lists': 'Lists',
  'launchpad.kpi.reports': 'Reports',
  'launchpad.kpi.jobs': 'Jobs',
  'launchpad.kpi.agents': 'Agents',
  'launchpad.kpi.rpa': 'RPA agents',
  'launchpad.kpi.skills': 'Skills',
  'launchpad.kpi.vectors': 'Vectors',
  'launchpad.kpi.apps': 'Apps',
  'launchpad.kpi.connections': 'Connections',
  'launchpad.kpi.entities': 'Entities',
  'launchpad.kpi.groups': 'Groups',
  'launchpad.kpi.groups.agents': 'Teams',
  'launchpad.kpi.groups.skills': 'Groups',
  'launchpad.kpi.favorites': 'Favorites',

  'launchpad.density.comfy': 'Comfy',
  'launchpad.density.compact': 'Compact',
  'launchpad.density.aria': 'Change tile density',

  'launchpad.actions.refresh': 'Reload',
  'launchpad.actions.retry': 'Retry',
  'launchpad.actions.open': 'Open',
  'launchpad.actions.add': 'Add',
  'launchpad.actions.add.processes': 'Add process',
  'launchpad.actions.add.lists': 'Add list',
  'launchpad.actions.add.jobs': 'Add job',
  'launchpad.actions.add.agents': 'Add agent',
  'launchpad.actions.add.rpa': 'Add RPA agent',
  'launchpad.actions.add.skills': 'Add skill',
  'launchpad.actions.add.vectors': 'Add vector',
  'launchpad.kebab.run': 'Run',
  'launchpad.kebab.history': 'Execution history',
  'launchpad.actions.import.skills': 'Import skill',
  'launchpad.actions.import.skillGroup': 'Import skill group',
  'launchpad.actions.add.apps': 'Add app',
  'launchpad.actions.add.connections': 'Add connection',
  'launchpad.actions.add.entities': 'Add entity',
  'launchpad.actions.addGroup.processes': 'Add group',
  'launchpad.actions.addGroup.lists': 'Add group',
  'launchpad.actions.addGroup.reports': 'Add group',
  'launchpad.actions.addGroup.connections': 'Add group',
  'launchpad.actions.addGroup.entities': 'Add group',
  'launchpad.actions.addGroup.agents': 'Add team',
  'launchpad.actions.addGroup.skills': 'Add group',
  'launchpad.actions.addSubgroup.processes': 'Add subgroup',
  'launchpad.group.actions.more': 'More group options',
  'launchpad.group.actions.detail': 'View details',
  'launchpad.group.actions.edit': 'Edit group',
  'launchpad.group.actions.delete': 'Delete group',
  'launchpad.group.actions.activate': 'Activate group',
  'launchpad.group.actions.deactivate': 'Deactivate group',
  'launchpad.group.delete.title': 'Delete group',
  'launchpad.group.delete.body':
    'Are you sure you want to delete the group "{name}"? This action cannot be undone.',

  'launchpad.status.inactive': 'Inactive',
  'launchpad.status.paused': 'Paused',
  'launchpad.status.premium': 'Premium',
  'launchpad.connection.validated': 'Validated',
  'launchpad.connection.public': 'Public',
  'launchpad.actions.activate': 'Activate',
  'launchpad.actions.deactivate': 'Deactivate',
  // Jobs schedule: IsActive only gates automatic materialization (UX §7.6).
  'launchpad.actions.pauseSchedule': 'Pause schedule',
  'launchpad.actions.resumeSchedule': 'Resume schedule',

  'launchpad.kebab.details': 'Details',
  'launchpad.kebab.edit': 'Edit',
  'launchpad.kebab.configure': 'Configure',
  'launchpad.kebab.delete': 'Delete',
  'launchpad.kebab.permissions': 'Permissions',
  'launchpad.kebab.validate': 'Validate',
  'launchpad.kebab.taskTraces': 'Task traces',
  'launchpad.kebab.advancedConfig': 'Advanced configuration',
  'launchpad.kebab.diagram': 'Diagram',
  'launchpad.kebab.processConfig': 'Process configuration',

  'launchpad.search.placeholder': 'Search processes, groups or favorites…',
  'launchpad.search.placeholder.processes': 'Search processes, groups or favorites…',
  'launchpad.search.placeholder.lists': 'Search lists, groups or favorites…',
  'launchpad.search.placeholder.reports': 'Search reports, groups or favorites…',
  'launchpad.search.placeholder.jobs': 'Search jobs…',
  'launchpad.search.placeholder.agents': 'Search agents…',
  'launchpad.search.placeholder.rpa': 'Search RPA agents…',
  'launchpad.search.placeholder.skills': 'Search skills…',
  'launchpad.search.placeholder.vectors': 'Search vectors…',
  'launchpad.search.placeholder.apps': 'Search apps…',
  'launchpad.search.placeholder.connections': 'Search connections or groups…',
  'launchpad.search.placeholder.entities': 'Search entities, groups or premium…',

  'launchpad.search.clear': 'Clear search',
  'launchpad.search.empty': 'No results for your search',
  'launchpad.search.meta': '{processes} results · {groups} groups found',
  'launchpad.search.tag.favorite': 'Favorite',
  'launchpad.search.tag.group': 'Group',
  'launchpad.search.tag.process': 'Process',
  'launchpad.search.tag.processes': 'Process',
  'launchpad.search.tag.lists': 'List',
  'launchpad.search.tag.reports': 'Report',
  'launchpad.search.tag.jobs': 'Job',
  'launchpad.search.tag.agents': 'Agent',
  'launchpad.search.tag.rpa': 'RPA agent',
  'launchpad.search.tag.skills': 'Skill',
  'launchpad.search.tag.vectors': 'Vector',
  'launchpad.search.tag.apps': 'App',
  'launchpad.search.tag.connections': 'Connection',
  'launchpad.search.tag.entities': 'Entity',
  'launchpad.search.hint.navigate': 'navigate',
  'launchpad.search.hint.activate': 'open',
  'launchpad.search.hint.close': 'close',

  'launchpad.progress.label': 'Loading {loaded} of {total} processes…',
  'launchpad.progress.processes': 'Loading {loaded} of {total} processes…',
  'launchpad.progress.lists': 'Loading {loaded} of {total} lists…',
  'launchpad.progress.reports': 'Loading {loaded} of {total} reports…',
  'launchpad.progress.jobs': 'Loading {loaded} of {total} jobs…',
  'launchpad.progress.agents': 'Loading {loaded} of {total} agents…',
  'launchpad.progress.rpa': 'Loading {loaded} of {total} RPA agents…',
  'launchpad.progress.skills': 'Loading {loaded} of {total} skills…',
  'launchpad.progress.vectors': 'Loading {loaded} of {total} vectors…',
  'launchpad.progress.apps': 'Loading {loaded} of {total} apps…',
  'launchpad.progress.connections': 'Loading {loaded} of {total} connections…',
  'launchpad.progress.entities': 'Loading {loaded} of {total} entities…',

  'launchpad.section.favorites': 'Favorites',
  'launchpad.section.groups': 'Groups',
  'launchpad.section.groups.agents': 'Teams',
  'launchpad.section.groups.skills': 'Groups',
  'launchpad.section.all': 'All processes',
  'launchpad.section.all.processes': 'All processes',
  'launchpad.section.all.lists': 'All lists',
  'launchpad.section.all.reports': 'All reports',
  'launchpad.section.all.jobs': 'All jobs',
  'launchpad.section.all.agents': 'All agents',
  'launchpad.section.all.rpa': 'All RPA agents',
  'launchpad.section.all.skills': 'All skills',
  'launchpad.section.all.vectors': 'All vectors',
  'launchpad.section.all.apps': 'All apps',
  'launchpad.section.all.connections': 'All connections',
  'launchpad.section.all.entities': 'All entities',
  'launchpad.section.results': 'Results',
  'launchpad.section.subgroups': 'Subgroups',
  'launchpad.section.processes': 'Processes',
  'launchpad.section.items.processes': 'Processes',
  'launchpad.section.items.lists': 'Lists',
  'launchpad.section.items.reports': 'Reports',
  'launchpad.section.items.jobs': 'Jobs',
  'launchpad.section.items.agents': 'Agents',
  'launchpad.section.items.rpa': 'RPA agents',
  'launchpad.section.items.skills': 'Skills',
  'launchpad.section.items.vectors': 'Vectors',
  'launchpad.section.items.apps': 'Apps',
  'launchpad.section.items.connections': 'Connections',
  'launchpad.section.items.entities': 'Entities',

  // Work board (agent view)
  'launchpad.jobs.agent.working': 'Working',
  'launchpad.jobs.agent.queued': 'Queued',
  'launchpad.jobs.agent.idle': 'Idle',
  'launchpad.jobs.agent.inactive': 'Inactive',
  'launchpad.jobs.agent.jobs': '{count, plural, one {# job} other {# jobs}}',
  'launchpad.jobs.agent.next': 'next {when}',
  'launchpad.jobs.agent.unassigned': 'No agent',
  'launchpad.jobs.next': 'Next',
  'launchpad.jobs.last': 'Last',
  'launchpad.jobs.frequency.custom': 'Custom frequency',
  'launchpad.jobs.details': 'Job details',
  'launchpad.jobs.repeat': 'Repeat',
  'launchpad.jobs.starts': 'First run',
  'launchpad.jobs.nextExecution': 'Next execution',
  'launchpad.jobs.lastExecution': 'Last execution',
  'launchpad.jobs.maxPending': 'Max pending',
  'launchpad.jobs.maxConcurrent': 'Max concurrent',
  'launchpad.jobs.recent': 'Recent executions',
  'launchpad.jobs.finished': 'finished {when}',
  'launchpad.jobs.attempts': '{count} attempts',
  'launchpad.jobs.viewHistory': 'View full history',
  'launchpad.jobs.execution.detail': 'View execution details',
  'launchpad.jobs.noExecutions': 'No executions yet',
  'launchpad.jobs.executionsLoading': 'Loading executions…',
  'launchpad.jobs.empty.title': 'Put your agents to work',
  'launchpad.jobs.empty':
    'No scheduled jobs yet. Create the first one with the + button and your agent will run it automatically on the frequency you define.',

  // RPA board (readonly Api catalog: agents → flows)
  'launchpad.rpa.empty.title': 'No RPA agents yet',
  'launchpad.rpa.empty':
    'When agents are registered they will appear here with their automation flows. Creation and edits happen in the RPA Designer.',
  'launchpad.rpa.agent.flows': '{count, plural, one {# flow} other {# flows}}',
  'launchpad.rpa.flowsLoading': 'Loading flows…',
  'launchpad.rpa.noFlows': 'This agent has no flows yet.',
  'launchpad.rpa.noExecutions': 'No executions yet',
  'launchpad.rpa.lastSeen': 'last seen {when}',
  'launchpad.rpa.session.loading': 'Loading device…',
  'launchpad.rpa.session.unavailable': 'Unavailable',
  'launchpad.rpa.session.retry': 'Retry loading device',
  'launchpad.rpa.unlinked.device': 'No device linked',
  'launchpad.rpa.lastExecution': 'Last execution',
  'launchpad.rpa.lastExecutionNumber': 'Execution number',
  'launchpad.rpa.lastExecutionStart': 'Started',
  'launchpad.rpa.lastExecutionEnd': 'Ended',
  'launchpad.rpa.duration': 'Duration',
  'launchpad.rpa.duration.seconds': '{count}s',
  'launchpad.rpa.duration.minutes': '{minutes}m {seconds}s',
  'launchpad.rpa.duration.hours': '{hours}h {minutes}m',
  'launchpad.rpa.flowDetails': 'Flow details',
  'launchpad.rpa.currentVersion': 'Current version',
  'launchpad.rpa.versionNone': 'No published version',
  'launchpad.rpa.versionPublished': 'v{number} · published',
  'launchpad.rpa.versionDraft': 'v{number}',
  'launchpad.rpa.versionChip': 'v{number}',
  'launchpad.rpa.versionsCount': 'Versions',
  'launchpad.rpa.versionsBreakdown': '{total} total · {published} published · {draft} draft',
  'launchpad.rpa.draft': 'Draft',
  'launchpad.rpa.execution.pending': 'Pending',
  'launchpad.rpa.execution.execution': 'Running',
  'launchpad.rpa.execution.finished': 'Finished',
  'launchpad.rpa.execution.canceled': 'Canceled',
  'launchpad.rpa.execution.error': 'Error',

  'launchpad.favorites.emptyTitle': "You don't have favorites yet",
  'launchpad.favorites.emptyHint': 'Star your most used processes to always keep them close.',
  'launchpad.favorites.emptyTitle.processes': "You don't have favorites yet",
  'launchpad.favorites.emptyHint.processes':
    'Star your most used processes to always keep them close.',
  'launchpad.favorites.emptyTitle.lists': "You don't have favorites yet",
  'launchpad.favorites.emptyHint.lists': 'Star your most used lists to always keep them close.',
  'launchpad.favorites.emptyTitle.reports': "You don't have favorites yet",
  'launchpad.favorites.emptyHint.reports': 'Star your most used reports to always keep them close.',
  'launchpad.favorites.emptyTitle.entities': "You don't have favorites yet",
  'launchpad.favorites.emptyHint.entities':
    'Star your most used entities to always keep them close.',

  'launchpad.rail.prev': 'Previous',
  'launchpad.rail.next': 'Next',

  'launchpad.group.open': 'Open group {name}',
  'launchpad.group.open.hint': 'Open',
  'launchpad.group.back': 'Back',
  'launchpad.group.backTo': 'Back to {name}',
  'launchpad.breadcrumb.home': 'Launchpad',
  'launchpad.group.meta':
    '{processes, plural, one {# process} other {# processes}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.processes':
    '{processes, plural, one {# process} other {# processes}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.lists':
    '{processes, plural, one {# list} other {# lists}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.reports':
    '{processes, plural, one {# report} other {# reports}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.connections':
    '{processes, plural, one {# connection} other {# connections}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.entities':
    '{processes, plural, one {# entity} other {# entities}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.agents':
    '{processes, plural, one {# agent} other {# agents}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',
  'launchpad.group.meta.skills':
    '{processes, plural, one {# skill} other {# skills}}{subgroups, plural, =0 {} one { · # subgroup} other { · # subgroups}}',

  'launchpad.group.empty': 'This group has no available processes yet.',
  'launchpad.group.empty.processes': 'This group has no available processes yet.',
  'launchpad.group.empty.lists': 'This group has no available lists yet.',
  'launchpad.group.empty.reports': 'This group has no available reports yet.',
  'launchpad.group.empty.connections': 'This group has no available connections yet.',
  'launchpad.group.empty.entities': 'This group has no available entities yet.',
  'launchpad.group.empty.agents': 'This team has no agents assigned yet.',
  'launchpad.group.empty.skills': 'This group has no skills assigned yet.',

  'launchpad.group.processesCount': '{count, plural, one {# process} other {# processes}}',
  'launchpad.group.processesCount.processes':
    '{count, plural, one {# process} other {# processes}}',
  'launchpad.group.listsCount': '{count, plural, one {# list} other {# lists}}',
  'launchpad.group.reportsCount': '{count, plural, one {# report} other {# reports}}',
  'launchpad.group.connectionsCount': '{count, plural, one {# connection} other {# connections}}',
  'launchpad.group.entitiesCount': '{count, plural, one {# entity} other {# entities}}',
  'launchpad.group.agentsCount': '{count, plural, one {# agent} other {# agents}}',
  'launchpad.group.skillsCount': '{count, plural, one {# skill} other {# skills}}',
  'launchpad.group.subgroupsCount': '{count, plural, one {# subgroup} other {# subgroups}}',
  'launchpad.group.noProcesses': 'No content yet',

  'launchpad.filters.aria': 'Filter by group',
  'launchpad.filters.active': 'Active',
  'launchpad.filters.all': 'All',
  'launchpad.filters.favorites': 'Favorites',
  'launchpad.filters.system': 'System',
  'launchpad.filters.premium': 'Premium',
  'launchpad.filters.inactive': 'Inactive',
  'launchpad.agent.team': 'Team: {name}',
  'launchpad.skill.group': 'Group: {name}',

  'launchpad.grid.empty': 'No results match the current filters.',
  'launchpad.grid.loadingMore': 'Loading more…',

  'launchpad.process.start': 'Open {name}',
  'launchpad.favorite.add': 'Add to favorites',
  'launchpad.favorite.remove': 'Remove from favorites',

  'launchpad.error.load': 'Something went wrong loading your Launchpad. Please try again.',
};
